var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, copyDefault, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && (copyDefault || key !== "default"))
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toESM = (module2, isNodeMode) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", !isNodeMode && module2 && module2.__esModule ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
var __toCommonJS = /* @__PURE__ */ ((cache) => {
  return (module2, temp) => {
    return cache && cache.get(module2) || (temp = __reExport(__markAsModule({}), module2, 1), cache && cache.set(module2, temp), temp);
  };
})(typeof WeakMap !== "undefined" ? /* @__PURE__ */ new WeakMap() : 0);

// src/index.tsx
var src_exports = {};
__export(src_exports, {
  Drawer: () => Drawer,
  DrawerBody: () => import_react5.DrawerBody,
  DrawerCloseButton: () => import_react5.DrawerCloseButton,
  DrawerContent: () => DrawerContent,
  DrawerFooter: () => import_react5.DrawerFooter,
  DrawerHeader: () => ModalHeader,
  DrawerOverlay: () => import_react5.DrawerOverlay,
  Modal: () => import_react6.Modal,
  ModalBody: () => import_react6.ModalBody,
  ModalCloseButton: () => import_react6.ModalCloseButton,
  ModalContent: () => import_react6.ModalContent,
  ModalFooter: () => import_react6.ModalFooter,
  ModalHeader: () => ModalHeader,
  ModalOverlay: () => import_react6.ModalOverlay,
  SimpleDrawer: () => SimpleDrawer
});

// src/Drawer.tsx
var import_react3 = require("@chakra-ui/react");
var import_react4 = __toESM(require("react"));
var import_react_swipeable = require("react-swipeable");
var import_react5 = require("@chakra-ui/react");

// src/ModalHeader.tsx
var import_react = require("@chakra-ui/react");
var import_react2 = __toESM(require("react"));
var ModalHeader = (0, import_react.forwardRef)((_a, ref) => {
  var _b = _a, { size } = _b, props = __objRest(_b, ["size"]);
  const styles = {
    fontSize: size === "lg" ? ["mobile.lg", "desktop.lg"] : ["mobile.md", "desktop.md"],
    textAlign: size === "lg" ? "center" : "left"
  };
  return /* @__PURE__ */ import_react2.default.createElement(import_react.ModalHeader, __spreadValues(__spreadProps(__spreadValues({}, props), {
    ref
  }), styles));
});

// src/Drawer.tsx
var Drawer = (props) => {
  return /* @__PURE__ */ import_react4.default.createElement(DrawerProvider, {
    placement: props.placement
  }, /* @__PURE__ */ import_react4.default.createElement(import_react3.Drawer, __spreadValues({}, props)));
};
var DrawerContent = (0, import_react3.forwardRef)((_a, ref) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  const placement = useDrawerContext();
  const { onClose } = (0, import_react3.useModalContext)();
  const handlers = (0, import_react_swipeable.useSwipeable)({
    onSwiped: (e) => {
      console.log(e);
      const shouldClose = placement === "bottom" && e.dir === "Down" || placement === "right" && e.dir === "Right" || placement === "left" && e.dir === "Left" || placement === "top" && e.dir === "Up" || placement === "end" && e.dir === "Right" || placement === "start" && e.dir === "Left";
      if (shouldClose) {
        onClose();
      }
    },
    swipeDuration: 500
  });
  const isTopOrBottom = placement === "top" || placement === "bottom";
  const widthConstraits = isTopOrBottom ? { width: ["100%", "37.5rem"], mx: "auto" } : {};
  return /* @__PURE__ */ import_react4.default.createElement(import_react3.Box, __spreadValues({}, handlers), /* @__PURE__ */ import_react4.default.createElement(import_react3.DrawerContent, __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, widthConstraits), {
    borderTopRadius: placement === "bottom" ? "md" : "none",
    borderBottomRadius: placement === "top" ? "md" : "none"
  }), props), {
    ref
  }), /* @__PURE__ */ import_react4.default.createElement(import_react3.Box, {
    position: "relative"
  }, isTopOrBottom && /* @__PURE__ */ import_react4.default.createElement(Notch, {
    top: placement === "bottom" ? 2 : void 0,
    bottom: placement === "top" ? 2 : void 0
  }), /* @__PURE__ */ import_react4.default.createElement(import_react3.Box, null, children))));
});
var Notch = (0, import_react3.forwardRef)((props, ref) => /* @__PURE__ */ import_react4.default.createElement(import_react3.Center, __spreadProps(__spreadValues({
  position: "absolute",
  left: 0,
  right: 0,
  zIndex: "modal"
}, props), {
  ref
}), /* @__PURE__ */ import_react4.default.createElement(import_react3.Box, {
  width: "2.265rem",
  height: 1,
  backgroundColor: "alias.steel",
  borderRadius: "xs"
})));
var DrawerContext = import_react4.default.createContext(void 0);
var DrawerProvider = (props) => /* @__PURE__ */ import_react4.default.createElement(DrawerContext.Provider, {
  value: props.placement
}, props.children);
var useDrawerContext = () => {
  return import_react4.default.useContext(DrawerContext);
};

// src/Modal.tsx
var import_react6 = require("@chakra-ui/react");

// src/SimpleDrawer.tsx
var import_react7 = __toESM(require("react"));
var SimpleDrawer = (_a) => {
  var _b = _a, {
    placement,
    children,
    title
  } = _b, props = __objRest(_b, [
    "placement",
    "children",
    "title"
  ]);
  return /* @__PURE__ */ import_react7.default.createElement(Drawer, __spreadValues({
    placement
  }, props), /* @__PURE__ */ import_react7.default.createElement(import_react5.DrawerOverlay, null), /* @__PURE__ */ import_react7.default.createElement(DrawerContent, null, /* @__PURE__ */ import_react7.default.createElement(import_react5.DrawerCloseButton, null), title && /* @__PURE__ */ import_react7.default.createElement(ModalHeader, null, title), /* @__PURE__ */ import_react7.default.createElement(import_react5.DrawerBody, null, children)));
};
module.exports = __toCommonJS(src_exports);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  SimpleDrawer
});
